export default __webpack_public_path__ + "static/media/phone.0ace4d93.svg";